module.exports = __webpack_public_path__ + "7d753ae9ca2048a1cf98fe08514844ac.png";